import { type OpenApiSchemaCategory } from '#shared/api/schema';
import { createCategoryMap } from './createCategoryMap';

type Options =
    | {
          categories: OpenApiSchemaCategory[];
      }
    | {
          mapCategories: Map<string, OpenApiSchemaCategory>;
      };

export function getCategoryChain(id: string, options: Options): Array<OpenApiSchemaCategory | string> {
    const mapCategories = 'mapCategories' in options ? options.mapCategories : createCategoryMap(options.categories);

    const queue = [id];
    const chain: Array<OpenApiSchemaCategory | string> = [];

    const set = new Set();

    while (queue.length > 0) {
        const current = queue.shift();

        if (!current) {
            continue;
        }

        const cat = mapCategories.get(current);

        if (!cat) {
            chain.unshift(current);

            continue;
        }

        chain.unshift(cat);

        if (cat.parent_id && !set.has(cat.parent_id)) {
            set.add(cat.parent_id);
            queue.push(cat.parent_id);
        }
    }

    return chain;
}
